/**
 * 草图绘制处理器支持的有限工具集合。
 *
 * 设计说明：
 * 1. 该对象是 Viewer、绘制管理器、绘制处理器与选择处理器共享的唯一来源；
 * 2. 每个值都必须对应 `SketchDrawingManager` 已注册的绘制处理器；
 * 3. 贝塞尔只属于样条或样式样条的曲线模式，不作为独立绘制工具暴露。
 */
export const SketchDrawingTool = {
    /** 选择工具。 */
    Select: 'select',
    /** 点绘制工具。 */
    Point: 'point',
    /** 线绘制工具。 */
    Line: 'line',
    /** 圆绘制工具。 */
    Circle: 'circle',
    /** 椭圆绘制工具。 */
    Ellipse: 'ellipse',
    /** 矩形绘制工具。 */
    Rectangle: 'rectangle',
    /** 圆弧绘制工具。 */
    Arc: 'arc',
    /** 多段线绘制工具。 */
    Polyline: 'polyline',
    /** 样条绘制工具。 */
    Spline: 'spline',
    /** 风格样条绘制工具。 */
    StyleSpline: 'style_spline',
    /** 多边形绘制工具。 */
    Polygon: 'polygon',
    /** 槽口绘制工具。 */
    Slot: 'slot',
} as const;

/** 草图绘制处理器支持的工具类型。 */
export type SketchDrawingTool =
    (typeof SketchDrawingTool)[keyof typeof SketchDrawingTool];

export type {SketchDrawingMouseDownPayload} from './SketchDrawingHandler';

